webpackJsonp([163574175828286],{

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HTMLContent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTMLContent = exports.HTMLContent = function HTMLContent(_ref) {
	  var content = _ref.content,
	      className = _ref.className;
	  return _react2.default.createElement('div', { className: className, dangerouslySetInnerHTML: { __html: content } });
	};
	
	var Content = function Content(_ref2) {
	  var content = _ref2.content,
	      className = _ref2.className;
	  return _react2.default.createElement(
	    'div',
	    { className: className },
	    content
	  );
	};
	
	Content.propTypes = {
	  content: _propTypes2.default.string,
	  className: _propTypes2.default.string
	};
	
	HTMLContent.propTypes = Content.propTypes;
	
	exports.default = Content;

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.contentPageQuery = exports.ContentPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Content = __webpack_require__(68);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentPageTemplate = exports.ContentPageTemplate = function ContentPageTemplate(_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      contentComponent = _ref.contentComponent;
	
	  var ContentPage = contentComponent || _Content2.default;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-primary is-bold' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'hero-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-12' },
	              _react2.default.createElement(
	                'h1',
	                { id: 'content', className: 'title' },
	                title
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          margin: '0 auto',
	          maxWidth: 960,
	          padding: '0px 1.0875rem 1.45rem',
	          paddingTop: 0
	        } },
	      _react2.default.createElement(
	        'section',
	        { className: 'section section--gradient' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-10 is-offset-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'content' },
	                  _react2.default.createElement(ContentPage, { content: content })
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	ContentPageTemplate.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  content: _propTypes2.default.string,
	  contentComponent: _propTypes2.default.object
	};
	
	var ContentPage = function ContentPage(_ref2) {
	  var data = _ref2.data;
	  var post = data.markdownRemark;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        post.frontmatter.meta_title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: post.frontmatter.meta_description }),
	      _react2.default.createElement('link', { rel: 'icon',
	        type: 'image/png',
	        href: '/img/pesilogo_32x32.png' })
	    ),
	    _react2.default.createElement(ContentPageTemplate, {
	      title: post.frontmatter.title,
	      content: post && post.html,
	      contentComponent: _Content.HTMLContent
	    })
	  );
	};
	
	ContentPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = ContentPage;
	var contentPageQuery = exports.contentPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-content-page-js-bbb340116bc0678a2cd2.js